const quotationMarks = ["22", "27", "60", "b4", "2018", "2019", "201c", "201d"];

export const isQuotationMark = (char: string) => quotationMarks.includes(char.charCodeAt(0).toString(16));
